//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DeleteRoleModel extends ModelBase {
      static readonly $typeName = 'DeleteRoleModel';
      public key: string;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/security/models/DeleteRoleModel.ts